module.exports = "/_next/static/media/Video2025A.bb3123b12d5aa3d9b1489917058cc1cb.mp4";